<template>
    <div class="app-main goods-stock">

        
        <div class="top-bar">
            <el-input placeholder="输入条形码/商品名称筛选" v-model="value" @change="search()" style="width:210px;">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>
        <!-- 商品列表 -->
        <el-card shadow="hover">
            <el-table ref="multipleTable" :data="tableData"  height="600" style="width: 100%">
                <el-table-column label="商品图片" fixed align="center" width="100">
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.sku_pic" :src="scope.row.sku_pic_url"  />
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="商品名称"  align="center"   show-overflow-tooltip></el-table-column>
                <el-table-column prop="attr_symbol_string"      align="center" label="规格" ></el-table-column>
                <el-table-column prop="barcode" align="center" label="条形码"></el-table-column>
                <el-table-column prop="created_at"  align="center" label="入库时间" ></el-table-column>
                <el-table-column prop="updated_at"  align="center" label="最近入库时间" ></el-table-column>
                <el-table-column prop="stock"  label="库存" align="center" ></el-table-column>
                <el-table-column prop="stock_new" label="在库库存" align="center"></el-table-column>
                <el-table-column prop="initial_stock"  label="初始库存" align="center" ></el-table-column>
                <el-table-column prop="initial_stock"  label="修改库存" align="center" >
                    <template slot-scope="scope">
                        <el-button  type="primary" plain size="mini" @click="showDetail(scope.row)">修改库存</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" :current-page.sync="page" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size" ></el-pagination>
        </el-card>
            <!-- 展开商品详情弹框 -->
    <el-dialog
      title="订单详情"
      :visible.sync="detail_modal"
      :close-on-click-modal="false"
      center
      width="1150px"
    >
      <el-card class="m-bottom-4">
        <el-row class="m-bottom-4">
           <el-col :span="12" class="row-height"
            >商品名称：{{ rows.name }}</el-col
            >
            <el-col :span="6" class="row-height"
            >条形码：{{ rows.barcode }}</el-col
            >
           
        </el-row>
        <el-row class="m-bottom-4">
            <el-col :span="6" class="row-height"
            >规格：{{ rows.attr_symbol_string }}</el-col
            >
           <el-col :span="6" class="row-height"
            >库存：{{ rows.stock }}</el-col
            >
            <el-col :span="6" class="row-height"
            >初始库存：{{ rows.initial_stock }}</el-col
            >
        </el-row>
          <el-row class="m-bottom-4">
            <el-col :span="3" style="line-height:40px;font-size:16px;">选择方式：</el-col>
            <el-col :span="21">
                <el-radio-group v-model="delivery_method">
                    <el-radio :label="1" border>公司自用</el-radio>
                    <el-radio :label="2" border>市场部开销</el-radio>
                    <el-radio :label="3" border>自然损耗</el-radio>
                    <el-radio :label="4" border>人为损坏</el-radio>
                    <el-radio :label="8" border>线下销售</el-radio>
                    <el-radio :label="7" border>库存出错</el-radio>
                </el-radio-group>
            </el-col>
          </el-row>
          <el-row class="m-bottom-4" v-if="delivery_method == 7">
              <el-col :span="3" style="line-height:40px;font-size:16px;">加减库存：</el-col>
              <el-col :span="21">
                <el-radio-group v-model="addDel">
                    <el-radio :label="1" border>减库存</el-radio>
                    <el-radio :label="2" border>加库存</el-radio>
                </el-radio-group>
              </el-col>
          </el-row>
          <el-row class="m-bottom-4">
              <el-col :span="3" style="line-height:40px;font-size:16px;">输入在库数量：</el-col>
               <el-col :span="21">
                   <el-input type="text" v-model="stock_new" :placeholder="delivery_method!=7?'需要减少的库存':'需要加减的库存'" style="width:280px;"></el-input>
               </el-col>
         </el-row>
         <el-row class="m-bottom-4">
              <el-col :span="3" style="line-height:40px;font-size:16px;">输入数量：</el-col>
               <el-col :span="21">
                   <el-input type="text" v-model="addNum" :placeholder="delivery_method!=7?'需要减少的库存':'需要加减的库存'" style="width:280px;"></el-input>
               </el-col>
         </el-row>
         <el-row class="m-bottom-4">
              <el-col :span="3" style="line-height:40px;font-size:16px;">输入备注：</el-col>
               <el-col :span="21">
                   <el-input type="text" v-model="remark" placeholder="请输入备注" style="width:280px;"></el-input>
               </el-col>
         </el-row>
      </el-card>
      <el-card class="m-bottom-4">
          <el-row class="m-bottom-4" style="text-align:center;">
              <el-button type="success" style="width:120px;" @click="update">
                  提交
              </el-button>
          </el-row>
      </el-card>
    </el-dialog>
    </div>
</template>



<script>

import { stock_list, goods_status, recommend_add, new_add, popular_add, stock_updata } from '@/api/warehouse.js'

import MImg   from './../../../components/Image'

export default {
    components: { MImg },
    data() {
        return {
            value:'',
            tableData:[],
            table_load:false,
            checkData:[],
            total:0,
            size:20,
            page:1,
            goods_modal:false,
            sku:[],
            goodsId:'',                   //商品ID
            detail_modal: false,
            sku_title: '',
            sku_modal: false,
            rows:'',
            delivery_method: 1,
            addDel: 1,
            addNum: '',
            remark: '',
            stock_new: ''
        }
    },
    methods: {

        search() {
            this.page = 1
            this.getData()
        },
        getData(){
            this.tableData = [];
            let params = {
                page:this.page,
            }
            if(this.value != ""){
                params.search = this.value;
            }
            stock_list(params).then(res => {
                console.log(res)
                if(res){
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size = res.data.per_page
                }else{
                    this.tableData = [];
                    // this.$message.error('Error')
                }
            })
        },
        update() {
            let params = {
                status: this.delivery_method,
                stock: this.addNum,
                action: 1,
                remarks: this.remark,
                stock_new: this.stock_new
            }
            if (this.delivery_method == 7) {
                params.action = this.addDel
            } else {
                 params.action = 1
            }
            stock_updata(this.rows.id,params).then(res => {  
                if(res){
                    this.$message({ message: res.msg, type: "success"})
                    this.getData();
                    this.detail_modal = false
                }
            })
        },
        showDetail(rows) {
            this.delivery_method = 1;
            this.addDel= 1;
            this.addNum= '';
            this.remark= '';
            this.stock_new = '';
            this.detail_modal =  true;
            this.rows = rows;
        },
        reloadData(page){
            this.page = page;
            this.getData();
            this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
        },
        goodsEdit(row,flag){
            let params = {
                status:flag
            }
            goods_status(row.id,params).then(res => {
                if(res){
                    this.$message({message:res.msg,type:'success'})
                    this.getData()
                }else{
                    this.$message.error(res.msg)
                }
            }).catch(err => {
                this.table_load = false;
                console.log(err)
            })
        },


        // 为你推荐
        recommend(row) {
            const params = {
                goods_id: row.id,
            }
            recommend_add(params).then(res => {
                if(res) {
                    row.recommend = 1
                    this.$message({message:res.msg,type:'success'})
                }
            })
        },

        // 新品首发
        newProduct(row) {
            const params = {
                goods_id: row.id,
            }
            new_add(params).then(res => {
                if(res) {
                    row.new_products = 1
                    this.$message({message:res.msg,type:'success'})
                }
            })
        },

        // 热销产品
        popular(row) {
            const params = {
                goods_id: row.id,
            }
            popular_add(params).then(res => {
                if(res) {
                    row.hot_sale = 1
                    this.$message({message:res.msg,type:'success'})
                }
            })
        },
    },
    created(){
        this.getData();
        
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
.goods-stock {
    .table-btns {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .el-button {
            margin-bottom: 5px;
        }
        .el-button+.el-button {
            margin-left: 0;
        }
    }
}
</style>
